import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Concluir Cadastro", -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "ant-row" }
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_5 = { class: "ant-row" }
const _hoisted_6 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_icone = _resolveComponent("icone")!
  const _component_selecionar_empresa = _resolveComponent("selecionar-empresa")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_cenario_fiscal_informacao_complementar = _resolveComponent("cenario-fiscal-informacao-complementar")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_cenario_fiscal_definicoes_estados_icms = _resolveComponent("cenario-fiscal-definicoes-estados-icms")!
  const _component_cenario_fiscal_definicao_ipi = _resolveComponent("cenario-fiscal-definicao-ipi")!
  const _component_cenario_fiscal_definicao_pis = _resolveComponent("cenario-fiscal-definicao-pis")!
  const _component_cenario_fiscal_definicao_cofins = _resolveComponent("cenario-fiscal-definicao-cofins")!
  const _component_cenario_fiscal_definicao_ibs_cbs = _resolveComponent("cenario-fiscal-definicao-ibs-cbs")!
  const _component_cenario_fiscal_excecoes = _resolveComponent("cenario-fiscal-excecoes")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_card = _resolveComponent("card")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    centered: "",
    width: 1100,
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    "wrap-class-name": "scroll-modal ss-modal-tributacoes"
  }, {
    title: _withCtx(() => [
      _createTextVNode("Cenário fiscal "),
      _createVNode(_component_a_switch, {
        checked: _ctx.state.cenarioFiscal.ativo,
        "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.cenarioFiscal.ativo) = $event)),
        style: {"float":"right"},
        "checked-children": "Ativo",
        "un-checked-children": "Inativo"
      }, null, 8, ["checked"])
    ]),
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", null, [
        ((_ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Incluir && _ctx.telaBase.permissaoDados.incluir) || (_ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Visualizar && _ctx.telaBase.permissaoDados.alterar))
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.salvar && _ctx.salvar(...args)))
            }, _hoisted_2))
          : _createCommentVNode("", true)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_skeleton, {
        loading: _ctx.telaBase.carregando
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form, { layout: "vertical" }, {
            default: _withCtx(() => [
              _createVNode(_component_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_tabs, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_tab_pane, {
                        key: "0",
                        tab: "DADOS PRINCIPAIS"
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                              _createVNode(_component_a_form_item, {
                                label: "Empresas",
                                class: "ss-margin-campos",
                                rules: [{ required: true }]
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_selecionar_empresa, {
                                    codigoSelecionado: _ctx.state.cenarioFiscal.codigoEmpresa,
                                    "onUpdate:codigoSelecionado": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.cenarioFiscal.codigoEmpresa) = $event)),
                                    disabled: true
                                  }, null, 8, ["codigoSelecionado"])
                                ]),
                                _: 1
                              })
                            ])
                          ], 512), [
                            [_vShow, _ctx.telaBase.apresentarEmpresas]
                          ]),
                          _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                              _createVNode(_component_a_form_item, {
                                label: "Nome",
                                class: "ss-margin-campos",
                                rules: [{ required: true }]
                              }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    maxlength: "250",
                                    class: "ant-input",
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.cenarioFiscal.nome) = $event))
                                  }, null, 512), [
                                    [_vModelText, _ctx.state.cenarioFiscal.nome]
                                  ])
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _createVNode(_component_cenario_fiscal_informacao_complementar, {
                            "informacao-complementar": _ctx.state.cenarioFiscal.informacaoComplementar,
                            "onUpdate:informacaoComplementar": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.cenarioFiscal.informacaoComplementar) = $event))
                          }, null, 8, ["informacao-complementar"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_tab_pane, {
                        key: "1",
                        tab: "ICMS"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_cenario_fiscal_definicoes_estados_icms, {
                            estados: _ctx.state.estados,
                            definicoes: _ctx.state.cenarioFiscal.definicoesIcms,
                            "onUpdate:definicoes": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.cenarioFiscal.definicoesIcms) = $event)),
                            "tipos-atividades": _ctx.state.tiposAtividadesIcms,
                            "onUpdate:tiposAtividades": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.tiposAtividadesIcms) = $event))
                          }, null, 8, ["estados", "definicoes", "tipos-atividades"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_tab_pane, {
                        key: "2",
                        tab: "IPI"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_cenario_fiscal_definicao_ipi, {
                            definicao: _ctx.state.cenarioFiscal.definicaoIpi,
                            "onUpdate:definicao": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.cenarioFiscal.definicaoIpi) = $event)),
                            "tipos-atividade": _ctx.state.tiposAtividadeIpi,
                            "onUpdate:tiposAtividade": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.tiposAtividadeIpi) = $event))
                          }, null, 8, ["definicao", "tipos-atividade"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_tab_pane, {
                        key: "3",
                        tab: "PIS"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_cenario_fiscal_definicao_pis, {
                            definicao: _ctx.state.cenarioFiscal.definicaoPis,
                            "onUpdate:definicao": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.cenarioFiscal.definicaoPis) = $event))
                          }, null, 8, ["definicao"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_tab_pane, {
                        key: "4",
                        tab: "COFINS"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_cenario_fiscal_definicao_cofins, {
                            definicao: _ctx.state.cenarioFiscal.definicaoCofins,
                            "onUpdate:definicao": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.cenarioFiscal.definicaoCofins) = $event))
                          }, null, 8, ["definicao"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_tab_pane, {
                        key: "5",
                        tab: "IBS/CBS"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_cenario_fiscal_definicao_ibs_cbs, {
                            definicao: _ctx.state.cenarioFiscal.definicaoIbsCbs,
                            "onUpdate:definicao": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.cenarioFiscal.definicaoIbsCbs) = $event))
                          }, null, 8, ["definicao"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_tab_pane, {
                        key: "6",
                        tab: "EXCEÇÕES"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_cenario_fiscal_excecoes, {
                            empresa: _ctx.state.cenarioFiscal.codigoEmpresa,
                            excecoesIcms: _ctx.state.cenarioFiscal.excecoesIcms,
                            "onUpdate:excecoesIcms": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.cenarioFiscal.excecoesIcms) = $event)),
                            excecoesIpi: _ctx.state.cenarioFiscal.excecoesIpi,
                            "onUpdate:excecoesIpi": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.cenarioFiscal.excecoesIpi) = $event)),
                            excecoesPis: _ctx.state.cenarioFiscal.excecoesPis,
                            "onUpdate:excecoesPis": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.cenarioFiscal.excecoesPis) = $event)),
                            excecoesCofins: _ctx.state.cenarioFiscal.excecoesCofins,
                            "onUpdate:excecoesCofins": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.cenarioFiscal.excecoesCofins) = $event)),
                            excecoesIbsCbs: _ctx.state.cenarioFiscal.excecoesIbsCbs,
                            "onUpdate:excecoesIbsCbs": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.cenarioFiscal.excecoesIbsCbs) = $event)),
                            estados: _ctx.state.estados,
                            "onUpdate:estados": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.estados) = $event))
                          }, null, 8, ["empresa", "excecoesIcms", "excecoesIpi", "excecoesPis", "excecoesCofins", "excecoesIbsCbs", "estados"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["loading"]),
      _createVNode(_component_requisicao_modal, {
        visivel: _ctx.modalBase.exibirRequisicaoModal,
        "onUpdate:visivel": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
        apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
        fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso,
        retornoRequisicao: _ctx.modalBase.retornoRequisicao
      }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "retornoRequisicao"])
    ]),
    _: 1
  }, 8, ["visible"]))
}